<template>
	<v-card>
		<v-card-text>
			<v-form ref="asset-management-global-form" v-model="valid">
				<v-row>
					<v-col>
						<label class="text-caption"> Asset ID </label>
						<v-text-field v-model="formData.AssetID"
							variant="outlined"
							density="compact"
							disabled
						/>
					</v-col>
					<v-col>
						<label class="text-caption"> Title </label>
						<v-text-field v-model="formData.Title"
							ref="globalTitle"
							variant="outlined"
							density="compact"
							:rules="[value => !!value || 'Title field is required']"
							:disabled="!editAssetFeatureEnabled"/>
					</v-col>
					<v-col>
						<label class="text-caption"> Album </label>
						<v-text-field v-model="formData.Album"
							variant="outlined"
							density="compact"
							:disabled="!editAssetFeatureEnabled"/>
					</v-col>
					<v-col>
						<label class="text-caption"> Artist </label>
						<v-text-field v-model="formData.Artist"
							variant="outlined"
							density="compact"
							:disabled="!editAssetFeatureEnabled"/>
					</v-col>
					<v-col>
						<label class="text-caption"> Voice </label>
						<v-text-field v-model="formData.Voice"
							placeholder="Voice"
							variant="outlined"
							density="compact"
							:disabled="!editAssetFeatureEnabled"/>
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						<label class="text-caption"> Duration </label>
						<v-text-field :model-value="secondsToFormat(formData.Duration, 'mm:ss')"
							variant="outlined"
							density="compact"
							readonly
						/>
					</v-col>
					<v-col>
						<label class="text-caption"> Length </label>
						<v-text-field :model-value="secondsToFormat(formData.Length, 'mm:ss')"
							variant="outlined"
							density="compact"
							readonly
						/>
					</v-col>
				</v-row>
			</v-form>

			<v-tabs v-model="activeTab">
				<v-tab
					v-for="(tab, index) in tabItems"
					:key="index"
					:text="tab"
					:value="index"
					variant="text"
					color="secondary"
					density="compact"
				></v-tab>
			</v-tabs>

			<AssetManagementGlobalMarksTab v-show="activeTab === 0" ref="marksTab"/>
			<AssetManagementGlobalExtraTab v-show="activeTab === 1" ref="extraTab"/>
<!--			<AssetManagementGlobalIngestTab v-if="activeTab === 2" ref="ingestTab"/>-->
		</v-card-text>
	</v-card>
</template>

<script>
/* Modules */
import AssetManagementGlobalMarksTab from "@/components/standaloneModules/AssetManagementGlobalMarksTab.vue";
import AssetManagementGlobalExtraTab from "@/components/standaloneModules/AssetManagementGlobalExtraTab.vue";

/* Enums */
import Modes from "@/enums/AssetManagementModeTypes";

/* Mixins */
import DurationFormatMixin from "@/mixins/DurationFormatMixin";

/* Libraries */
import _ from "lodash";

export default {
	name: "AssetManagementGlobalTab",

	components: {AssetManagementGlobalExtraTab, AssetManagementGlobalMarksTab},

	mixins: [DurationFormatMixin],

	data() {
		return {
			activeTab: 0,
			// todo: enable to show ingest tab
			// tabItems: ["Marks", "Extra", "Ingest"],
			tabItems: ["Marks", "Extra"],
			formData: {},
			valid: true
		}
	},

	computed: {
		event() {
			return this.$store.getters.getAssetManagementEvent();
		},

		asset() {
			return this.$store.getters.getAssetManagementAsset();
		},

		mode() {
			return this.$store.getters.getAssetManagementMode();
		},

		editAssetFeatureEnabled() {
			if (_.isNil(this.asset)) 
{return false;}
			return this.$store.getters.isFeatureEnabledByAssetTypeID({
				object_id: this.$store.getters.assetManagementStationID(),
				reference: "zettacloud_asset_edit",
				asset_type_id: this.asset.AssetTypeID
			});
		}
	},

	methods: {
		initFormData() {
			this.formData = {
				AssetID: this.asset?.AssetID,
				Title: this.asset?.Title,
				Album: this.asset?.Album,
				Artist: this.asset?.Artist,
				Voice: this.asset?.Voice,
				Duration: this.asset?.DurationToSegue ?? this.asset?.POIMarkup?.Length ?? 0,
				Length: this.asset?.POIMarkup?.Length ?? 0
			}
		},

		async getData() {
			if (!this.formData.Title) {
				return Promise.reject(new Error("Title is required"));
			}
			let globalData = {};
			if (this.asset) {
				globalData = _.pickBy(
					_.omit(this.formData, ["Duration", "Length"]),
					(value, key) => !_.isEqual(value, this.asset[key])
				);
			}
			else {
				globalData = _.omit(this.formData, ["Duration", "Length"]);
			}
			const [marksData, extraData] = await Promise.all([
				this.$refs.marksTab.getData(),
				this.$refs.extraTab.getData()
			]);

			return {
				globalData,
				marksData,
				extraData
			}
		}
	},

	watch: {
		asset() {
			if (!this.asset) {
				this.activeTab = 0;
			}
			this.initFormData();
		},

		mode() {
			if (this.mode === Modes.Edit) {
				this.tabItems = ["Marks", "Extra", "Ingest"];
			}
			else {
				this.tabItems = ["Marks", "Extra"];
			}
		}
	},

	mounted() {
		this.initFormData();
	}

}
</script>

<style scoped lang="scss">

</style>